import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWrite: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWrite"><Path d="M21.5 11.6622L17.3378 7.5L7.5 17.3378V21.5H11.6622L21.5 11.6622Z" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 3.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 7.5H10.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 11.5H7.5022" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWrite;
